import api from './axios';

export async function uploadNewsletterMedia(file, type, onProgress) {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('type', type || 'headline');
  const { data } = await api.post('/sent-emails/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress
      ? (e) => {
          const percent = e.total ? Math.round((e.loaded * 100) / e.total) : 0;
          onProgress(percent);
        }
      : undefined,
  });
  return data;
}

export async function sendNewsletter(payload) {
  const { data } = await api.post('/sent-emails', payload);
  return data.sentEmail;
}

export async function fetchSentEmails() {
  const { data } = await api.get('/sent-emails');
  return data.sentEmails || [];
}
